import { render, staticRenderFns } from "./DpadForm1.vue?vue&type=template&id=0553eb75"
import script from "./DpadForm1.vue?vue&type=script&lang=js"
export * from "./DpadForm1.vue?vue&type=script&lang=js"
import style0 from "./DpadForm1.vue?vue&type=style&index=0&id=0553eb75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports